<template>
  <div
    :class="{ required: data.required }"
    class="field">
    <label>{{ $t(data.label) }}</label>
    <select
      v-model="input"
      class="ui search fluid dropdown">
      <option :value="null">
        {{ $t(data.placeholder) }}
      </option>
      <option
        v-for="timeslot in timeslots"
        :key="timeslot"
        :value="timeslot">
        {{ $d(new Date(timeslot), 'time') }}
      </option>
    </select>
  </div>
</template>

<script>
// specialized dropdown for timeslots

export default {
  name: 'DropdownInput',
  props: {
    data: {
      type: Object,
      required: true
    },
    value: {
      validator: (value) => {
        return (value === null || ['undefined', 'string', 'number'].includes(typeof value))
      },
      required: true
    }
  },
  data () {
    return {
      input: this.value,
      timeslots: []
    }
  },
  created () {
  },
  mounted () {
    this.initializeTimeslots()

    $('.ui.dropdown').dropdown()
  },
  watch: {
    input: {
      handler: function (value) {
        this.$emit('input', this.input)
      },
      deep: true
    }
  },
  methods: {
    initializeTimeslots () {
      let second = 1000
      let minute = 60 * second
      let hour = 60 * minute
      let fiveMinutes = 5 * minute
      let sevenAm = 7 * hour
      let eightPm = 20 * hour

      for (let i = sevenAm; i <= eightPm; i += fiveMinutes) {
        this.timeslots.push(i)
      }
    }
  }
}
</script>

<style scoped>

</style>
